import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { User } from '@shared/graphql/generated';

@Component({
  selector: 'evland-avatar-placeholder',
  standalone: true,
  imports: [],
  templateUrl: './avatar-placeholder.component.html',
  styleUrl: './avatar-placeholder.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarPlaceholderComponent {
  user = input.required<User>();
  rounded = input<boolean>(true);
  initials: Signal<string>;

  constructor() {
    this.initials = computed(() => {
      const user = this.user();

      if (!user) return null;

      const { email, first_name, last_name } = user;
      let arr;

      if (first_name || last_name) {
        arr = [first_name, last_name]
      } else if (email) {
        arr = [ email.split('@')[0] ];
      } else {
        arr = [$localize `Користувач`]
      }

      return arr ? arr.filter(Boolean).map(value => value[0].toUpperCase()).join('') : null;
    });
  }

}
